import { field, type FieldsOf } from "@/admin/FieldConfig.tsx";
import type { MetalLease } from "@warrenio/api-spec/spec.oats.gen";

export const leaseFields = {
    display_name: field("Name", (e) => e.display_name),
    requested_os_id: field("Requested OS", (e) => e.requested_os_id),
} satisfies FieldsOf<MetalLease>;
